import { render, staticRenderFns } from "./AgencyManagerMoveComponent.vue?vue&type=template&id=2dc274c2&scoped=true"
import script from "./AgencyManagerMoveComponent.vue?vue&type=script&lang=js"
export * from "./AgencyManagerMoveComponent.vue?vue&type=script&lang=js"
import style0 from "./AgencyManagerMoveComponent.vue?vue&type=style&index=0&id=2dc274c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc274c2",
  null
  
)

export default component.exports